var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.active ? 'is-active' : ''},[_c('router-link',{attrs:{"to":{ name: _vm.view, params: _vm.params }}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }